
// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './time-content.component.css';
import participantService from '../../services/participants.service';

var TimeContent = CreateReactClass({
    getInitialState: function () {
        return {};
    },
    render: function () {

        return (
            <div className="TimeContent flexComponentNone colFlexStart " style={{width : 150, 'box-sizing': 'border-box'}}>

                <div className="flexComponentNone ligneFlexStartCentered" style={{backgroundColor : 'black', borderRadius : 4}}>
                    <span className="fa fa-calendar fa-lg " style={{padding : '0px 10px 0px 10px', color:'white'}}></span>
                    <input name="_Dime" id="_Dime" style={{width : 120, minWidth : 120 }} type="date" min={participantService.meetDateAndTime.meetDateMin}  max={participantService.meetDateAndTime.meetDateMax} required="required" step="1" value={this.props.date} autoComplete="true" onChange={this.props.handleDateChange} />
                </div>

                <div className="flexComponentNone ligneFlexStartCentered" style={{backgroundColor : 'black', marginTop: 8, borderRadius : 4}}>
                    <span className="fa fa-clock-o fa-lg" style={{padding : '0px 10px 0px 10px', color:'white'}}></span>
                    <input name="_Time" id="_Time" style={{width : 100, minWidth : 100 }} type="time" step="5" autoComplete="true" required="required" value={this.props.time} onChange={this.props.handleTimeChange} />
                </div>

            </div>
        )
    }
});

module.exports = TimeContent;





// WEBPACK FOOTER //
// ./src/components/areaFinder/time-content.component.js